<template>
    <div class="text-center">
        <Boolean :value="props.value" />
    </div>
</template>

<script setup lang="ts">
import type { GridComponent } from '@src/Common/Components/types';

const props = withDefaults(defineProps<GridComponent>(), {});
//
</script>
